import React from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import messages from './WrongDirectorDetailsError.messages';
import InternalLink from '../../../../components/InternalLink';
import { AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP } from '../../AutomatedLendingDecision.actions';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
    goToStepOne: () =>
        dispatch({
            type: AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP,
            step: 'businessIntroduction'
        })
});

class WrongDirectorDetailsError extends React.Component {
    renderTitle = () => {
        return (
            <div className="title-text">
                <FormattedMessage {...messages.title} />
            </div>
        );
    };

    renderMessage = () => {
        const messageCheckDetailsLink = this.renderMessageCheckDetailsLink();

        return (
            <div className="content-text" data-testid="error-details-text">
                <FormattedMessage
                    {...messages.message}
                    values={{ messageCheckDetailsLink }}
                />
            </div>
        );
    };

    renderMessageCheckDetailsLink = () => {
        const { goToStepOne } = this.props;

        return (
            <InternalLink onClick={goToStepOne}>
                <FormattedMessage {...messages.messageCheckDetailsLink} />
            </InternalLink>
        );
    };

    render() {
        const title = this.renderTitle();
        const message = this.renderMessage();

        return (
            <div>
                {title}
                {message}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WrongDirectorDetailsError);
